import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import { Notification } from '../../../../config/Global';
import FormComponent from './FormComponent';

const EditComponent = observer((props) => {
	const { visible, onClose } = props;
	const [form] = Form.useForm();
	const { TOURPACKAGECATEGORY } = useStore();
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		if (visible && TOURPACKAGECATEGORY.categoryDetail) {
			form.setFieldsValue({
				name: TOURPACKAGECATEGORY.categoryDetail.name,
				sortOrder: TOURPACKAGECATEGORY.categoryDetail.sortOrder,
			});
			setDisabled(false);
		}
	}, [visible, TOURPACKAGECATEGORY.categoryDetail, form]);

	const handleSubmit = async (data) => {
		setSaving(true);
		try {
			const response = await TOURPACKAGECATEGORY.editCategory({
				...data,
				id: TOURPACKAGECATEGORY.categoryDetail.id,
				versionNo: TOURPACKAGECATEGORY.categoryDetail.versionNo,
			});

			if (response.httpStatusCode === 200) {
				Notification.success({
					message: 'Tour Package Category Updated successfully!',
				});
				closeModal();
			}
		} catch (error) {
			Notification.error({
				message: 'Error updating tour package category ',
			});
		} finally {
			setSaving(false);
		}
	};

	const handleChange = async () => {
		form.validateFields({ validateOnly: true })
			.then(() => {
				setDisabled(false);
			})
			.catch(() => {
				setDisabled(true);
			});
	};

	const closeModal = () => {
		setDisabled(true);
		form.resetFields();
		TOURPACKAGECATEGORY.categoryDetail = null;
		onClose();
	};

	return (
		<Modal
			title="Edit Tour Package Category"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="EditForm"
					>
						Update Tour Package Category
					</Button>
					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<FormComponent
				id="EditForm"
				form={form}
				onFinish={handleSubmit}
				handleChange={handleChange}
			/>
		</Modal>
	);
});

export default EditComponent;
